import { useState } from 'react';
import Button from '../base/Button';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-950/90 backdrop-blur-md border-b border-amber-200/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" className="text-2xl font-bold text-gradient-gold hover:glow-gold transition-all duration-300" style={{fontFamily: '"Pacifico", serif'}}>
              Fortal Society
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <a href="/" className="text-slate-300 hover:text-amber-400 px-3 py-2 text-sm font-medium transition-colors duration-200">
                Home
              </a>
              <a href="/risultati" className="text-slate-300 hover:text-amber-400 px-3 py-2 text-sm font-medium transition-colors duration-200">
                Risultati
              </a>
              <a href="/servizi" className="text-slate-300 hover:text-amber-400 px-3 py-2 text-sm font-medium transition-colors duration-200">
                Servizi
              </a>
              <a href="/corsi" className="text-slate-300 hover:text-amber-400 px-3 py-2 text-sm font-medium transition-colors duration-200">
                Corsi
              </a>
            </div>
          </div>

          {/* Desktop CTA Button */}
          <div className="hidden md:block">
            <a href="https://t.me/communityfreefortal" target="_blank" rel="noopener noreferrer">
              <Button variant="primary" size="sm" className="animate-pulse-gold hover-lift">
                <div className="w-4 h-4 flex items-center justify-center mr-2">
                  <i className="ri-telegram-line"></i>
                </div>
                Entra in Community
              </Button>
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-slate-300 hover:text-amber-400 focus:outline-none focus:text-amber-400 transition-colors duration-200"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-slate-900/95 backdrop-blur-md rounded-lg mt-2 border border-amber-200/20">
              <a 
                href="/" 
                onClick={closeMenu}
                className="text-slate-300 hover:text-amber-400 block px-3 py-2 text-base font-medium transition-colors duration-200"
              >
                Home
              </a>
              <a 
                href="/risultati" 
                onClick={closeMenu}
                className="text-slate-300 hover:text-amber-400 block px-3 py-2 text-base font-medium transition-colors duration-200"
              >
                Risultati
              </a>
              <a 
                href="/servizi" 
                onClick={closeMenu}
                className="text-slate-300 hover:text-amber-400 block px-3 py-2 text-base font-medium transition-colors duration-200"
              >
                Servizi
              </a>
              <a 
                href="/corsi" 
                onClick={closeMenu}
                className="text-slate-300 hover:text-amber-400 block px-3 py-2 text-base font-medium transition-colors duration-200"
              >
                Corsi
              </a>
              <div className="pt-2">
                <a href="https://t.me/communityfreefortal" target="_blank" rel="noopener noreferrer" className="block">
                  <Button 
                    variant="primary" 
                    size="sm" 
                    className="w-full text-sm animate-pulse-gold hover-lift"
                    onClick={closeMenu}
                  >
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-telegram-line"></i>
                    </div>
                    Entra in Community
                  </Button>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
